import { Navigate, Outlet } from 'react-router'

import { paths } from '@/app/navigation'
import { PageLoader } from '@/components/common/page-loader'
import { ErrorFallback } from '@/components/errors/error-fallback'
import { selectCurrentUser, useDirectory } from '@/modules/accounts'
import { useAppSelector } from '@/store/hooks'


// These guards stop the UI from rendering pages a user shouldn't see. They run in the browser, so they are a convenience,
// not security: access control belongs on the backend. Commands and selectors check the same rules.

/** Sends signed-out visitors to the login page. */
export function RequireAuth() {
  const session = useAppSelector((state) => state.auth.session)
  const user = useAppSelector(selectCurrentUser)
  const directory = useDirectory(Boolean(session))
  if (!session) return <Navigate to={paths.login} replace />
  // Who the user is comes from the backend, so nothing renders until that has loaded.
  if (!user && directory.isPending) return <PageLoader label="Loading your workspace…" />
  if (!user && directory.isError) return <ErrorFallback error={directory.error} onReset={() => void directory.refetch()} fullScreen />
  // Signed in as someone the backend no longer has.
  if (!user) return <Navigate to={paths.login} replace />
  return <Outlet />
}

/** The Users screen is open to every signed-in user; non-admins see their own account's people, read-only. */
export function RequireUsersAccess() {
  const user = useAppSelector(selectCurrentUser)
  if (!user) return <Navigate to={paths.login} replace />
  return <Outlet />
}

/** Fallback for unknown URLs: everyone lands on Projects. */
export function HomeRedirect() {
  const user = useAppSelector(selectCurrentUser)
  return <Navigate to={user ? paths.projects : paths.login} replace />
}
